import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '@iconify/react';

export default function DialogMensajeLimiteCancelar({ data }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Box>
      <Button variant="contained" color="error" onClick={() => setOpenDialog(true)}>
        Solicitar cancelacion
      </Button>
      <DialogBody open={openDialog} onClose={setOpenDialog} data={data} />
    </Box>
  );
}

function DialogBody({ open, onClose, data }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <Typography>
          La cancelacion solo se podra realizar el mismo dia del pago de la guia, para solicitar la cancelacion de este
          envio comuniquese con soporte de Dagpacket mediante nuestro correo electronico{' '}
          <Typography fontSize="18px" component="span" variant="subtitle2">
            soporte@dagpacket.com.mx
          </Typography>{' '}
          y envie el motivo de la cancelacion y el dagpacketCode:{' '}
          <Typography fontSize="18px" component="span" variant="subtitle2">
            {data.object_id}
          </Typography>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
